var React = require('react');

function Time (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_4109","data-name":"Group 4109","transform":"translate(-212 -648)"},[React.createElement("path",{"id":"Path_2628","data-name":"Path 2628","d":"M275.13,172.445v3.485a.487.487,0,0,0,.145.348L277.8,178.8l.7-.726-2.352-2.352v-3.281Z","transform":"translate(-55.145 479.555)","fill":"#1c1c55","key":0}),React.createElement("path",{"id":"Path_2629","data-name":"Path 2629","d":"M9.132,34.445a7,7,0,0,0-6.911,6.011H.13l2.5,2.5,2.5-2.5H3.208A6.022,6.022,0,1,1,4.4,45.131l-.784.61a7,7,0,1,0,5.517-11.3Z","transform":"translate(211.87 613.555)","fill":"#1c1c55","key":1})]));
}

Time.defaultProps = {"width":"16","height":"13.996","viewBox":"0 0 16 13.996"};

module.exports = Time;

Time.default = Time;
